import React, { createContext, useContext, useState } from 'react';
import { initialTransactions } from '../utils/mockData';

const DashboardContext = createContext(undefined);

export const DashboardProvider = ({ children }) => {
  const [transactions, setTransactions] = useState(() => {
    try {
      const saved = localStorage.getItem('finance-transactions');
      return saved ? JSON.parse(saved) : initialTransactions;
    } catch {
      return initialTransactions;
    }
  });

  const [userRole, setUserRole] = useState(() => {
    return localStorage.getItem('finance-user-role') || 'admin';
  });

  const saveTransactions = (txns) => {
    setTransactions(txns);
    localStorage.setItem('finance-transactions', JSON.stringify(txns));
  };

  const handleSetRole = (role) => {
    setUserRole(role);
    localStorage.setItem('finance-user-role', role);
  };

  const addTransaction = (transaction) => {
    const newTxn = { ...transaction, id: Date.now().toString() };
    saveTransactions([newTxn, ...transactions]);
  };

  const updateTransaction = (id, updates) => {
    saveTransactions(transactions.map((t) => (t.id === id ? { ...t, ...updates } : t)));
  };

  const deleteTransaction = (id) => {
    saveTransactions(transactions.filter((t) => t.id !== id));
  };

  return (
    <DashboardContext.Provider
      value={{ transactions, addTransaction, updateTransaction, deleteTransaction, userRole, setUserRole: handleSetRole }}
    >
      {children}
    </DashboardContext.Provider>
  );
};

export const useDashboard = () => {
  const ctx = useContext(DashboardContext);
  if (!ctx) throw new Error('useDashboard must be used within DashboardProvider');
  return ctx;
};
